import { DateTime } from "luxon"

export const isDateRangeExpired = (
    fechaFin: string | Date | null | undefined,
    zona_horaria = "America/Mexico_City"
): boolean => {
    if (!fechaFin) return false

    const endDate = DateTime.fromISO(
        typeof fechaFin === "string" ? fechaFin : fechaFin.toISOString()
    ).setZone(zona_horaria).startOf("day")

    if (!endDate.isValid) return false

    const today = DateTime.now().setZone(zona_horaria).startOf("day") 

    return today > endDate
}

export function formatDate(date?: string | Date, days = 0) {
    if (!date) return null
    const newDate = new Date(date)

    if(days === 0) {
        return newDate.toLocaleDateString('sv-SE'); 
    }

    newDate.setDate(newDate.getDate() + Number(days))
    return newDate.toISOString().split("T")[0]
}